import { ChangeInternalFontSize } from "features/CenterContent/RoleContent/VehicleChecklist/ChecklistCustomStyle";
import {
  CheckListType,
  getChecklistText,
} from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import { FilterChip, Flex, Text } from "shared/components/Spor";

interface FilterChipsProps {
  filter: string[];
  onFilterToggle: (filterToToggle: string) => void;
}

export const FilterChips = ({ filter, onFilterToggle }: FilterChipsProps) => (
  <Flex gap={1} alignItems="center">
    <Text pl="12px">Vis</Text>
    {Object.values(CheckListType).map((type) => (
      <ChangeInternalFontSize key={type}>
        <FilterChip
          size="sm"
          variant="core"
          checked={filter.includes(type)}
          onCheckedChange={() => onFilterToggle(type)}
        >
          <Text fontWeight="400">{getChecklistText(type)}</Text>
        </FilterChip>
      </ChangeInternalFontSize>
    ))}
  </Flex>
);
